<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      hr_leaves: [],
      leaglConditions: [
        { name: "Yes", value: 1 },
        { name: "No", value: 0 },
      ],
      HrLeaveTypes: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrLeaveTypes: null,
      HrLeaveTypesSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addHrLeaveTypes() {
      var data = {
        title: "popups.add",
        inputs: [
          { model: "name", type: "text", label: "name" },
          { model: "descr", type: "text", label: "descr" },
          {
            model: "is_legal",
            type: "select",
            options: (() => {
              return this.leaglConditions.map((data) => {
                return { value: data.value, label: data.name };
              });
            })(),
            label: "is legal",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("hr-leave-types", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrLeaveTypes(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          { model: "name", type: "text", label: "name", value: app.name },
          { model: "descr", type: "text", label: "descr", value: app.descr },
          {
            model: "is_legal",
            type: "text",
            label: "is_legal",
            value: app.is_legal,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("hr-leave-types", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.HrLeaveTypesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-leave-types/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.HrLeaveTypes = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrLeaveTypesSearchMode = false;
      this.get(this.page);
    },

    getHrLeaveTypes() {
      this.http.get("hr-leave-types").then((res) => {
        this.HrLeaveTypes = res.data;
      });
    },
    deleteHrLeaveTypes(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("hr-leave-types", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("hr-leave-types/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrLeaveTypes = res.data;
        });
    },
  },
  created() {
    this.get(1);
  },
};
</script>

<template>

    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.hr.subItems.leaves')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="HrLeaveTypesSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addHrLeaveTypes()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("hr_leave_types.id") }}</th>
          <th scope="col">{{ $t("hr_leave_types.name") }}</th>
          <th scope="col">{{ $t("hr_leave_types.descr") }}</th>
          <th scope="col">{{ $t("hr_leave_types.is_legal") }}</th>
          <th scope="col">{{ $t("hr_leave_types.created") }}</th>
          <th scope="col">{{ $t("hr_leave_types.updated") }}</th>
          <th scope="col">{{ $t("hr_leave_types.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="app in HrLeaveTypes" :key="app" class="text-center">
          <td>{{ app.id }}</td>
          <td>{{ app.name }}</td>
          <td>{{ app.descr }}</td>
          <td>{{ app.is_legal ? "Yes" : "No" }}</td>
          <td>{{ app.created.split("T")[0] }}</td>
          <td>{{ app.updated.split("T")[0] }}</td>

          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editHrLeaveTypes(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteHrLeaveTypes(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  Pagination     -->
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->

</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
